import React, { useEffect, useState } from "react";
import { CalendarIconSvg, InfoIconSvg, MoonIconSvg, OneWayTripIconSvg, RoundTripIconSvg, ShipIconSvg, UserIconSvg } from "../../../../assets/svg";
import { ISsrData } from "../../../../components/Modals/ViewDetailModal/ViewDetailModal";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { getBookingInfo } from "../../../../api/quotation.api";
import { splitDate } from "../../../../utils/splitDate";
import PriceDetail from "../../../AddLeads/stepThree/Components/PriceDetail";
import BookingsCabinCard from "./BookingsCabinCard/BookingsCabinCard";
import BookingsSsrSection from "./BookingsSsrSection/BookingsSsrSection";
import CustomButton from "../../../../components/CustomButton/CustomButton";
import dayjs from "dayjs";
import "./style.scss";

interface ViewBookingsDetailsModalProp {
  bookingId: string;
}

const ViewBookingsDetailsModal: React.FC<ViewBookingsDetailsModalProp> = ({ bookingId }) => {
  const [price, setPrice] = useState({ total: 0, cabin_names: [], cabin_fares: [], ssr_names: [], ssr_fares: [], service_tax_and_levies: 0, gst: 0, discount_category: {}, discount: 0, port_charges: 0, gratuity: 0, fuel_surcharge: 0 });
  const [bookingInfo, setBookingInfo] = useState<any>({});
  const [ssrData, setSsrData] = useState<ISsrData[]>([]);
  const [tabSwitch, setTabSwitch] = useState<1 | 2 | 3>(1);

  const handleTripType = (tripType: string) => {
    return tripType?.includes('one') ? 'One Way Trip' : 'Round Trip';
  }

  useEffect(() => {
    const fetchBookingInfo = async() => {
      const response = await getBookingInfo(bookingId);
      setBookingInfo(response?.result);
      // const flattenedSsrData = bookingData?.quotation?.items
      // ?.map((item: any) => item?.specialRequestDetails?.map((req: ISsrData) => ({ name: req?.name, price: req?.price, status: req?.status })))
      // .flat();
      // setSsrData(flattenedSsrData);
      let tempObj: any = { total: 0, cabin_names: [], cabin_fares: [], ssr_names: [], ssr_fares: [], service_tax_and_levies: 0, gst: 0, discount: 0, discount_category: '', port_charges: 0, gratuity: 0, fuel_surcharge: 0 };
      response?.result?.pricing?.forEach((value: any) => {
        const discountCategoryObject = value?.discount_category?.reduce((acc: any, discountName: string) => {
          acc[discountName] = true;
          return acc;
        }, {});
        if (value.type === 'CABIN') {
          tempObj = {
            ...tempObj,
            total: tempObj.total + value.cabin_fare + value.service_tax_and_levies + value.gst + value.fuel_surcharge,
            cabin_names: [...tempObj.cabin_names, value.title],
            cabin_fares: [...tempObj.cabin_fares, value.cabin_fare],
            service_tax_and_levies: tempObj.service_tax_and_levies + value.service_tax_and_levies,
            gst: tempObj.gst + value.gst,
            discount_category: { ...tempObj.discount_category, ...discountCategoryObject },
            discount: tempObj.discount + value.discount,
            port_charges: tempObj.port_charges + value.port_charges,
            gratuity: tempObj.gratuity + value.gratuity,
            fuel_surcharge: tempObj.fuel_surcharge + value.fuel_surcharge,
          };
        } else {
          tempObj = {
            ...tempObj,
            total: tempObj.total + value.total + value.service_tax_and_levies + value.gst + value.fuel_surcharge,
            ssr_names: [...tempObj.ssr_names, value.title],
            ssr_fares: [...tempObj.ssr_fares, value.total],
            service_tax_and_levies: tempObj.service_tax_and_levies + value.service_tax_and_levies,
            gst: tempObj.gst + value.gst,
            discount_category: { ...tempObj.discount_category, ...discountCategoryObject },
            discount: tempObj.discount + value.discount,
            port_charges: tempObj.port_charges + value.port_charges,
            gratuity: tempObj.gratuity + value.gratuity,
            fuel_surcharge: tempObj.fuel_surcharge + value.fuel_surcharge
          };
        }
      });
      setPrice({ ...tempObj });
    }
    fetchBookingInfo();
  }, [bookingId]);

  return (
    <div className="view-itinerary-modal-wrapper flex flex-col gap-3">
      <div className="flex gap-4 items-center">
        <span className="heading-text text-uppercase">Booking Details</span>
        <span className="text-lg text-[#92278f]">{`[${bookingInfo?.number}]`}</span>
      </div>
      <div className="guest-details-wrapper flex gap-20">
        <div className="flex flex-col gap-2">
          <span className="detail-name">Guest Name</span>
          <span>
            {bookingInfo?.customer?.first_name || 'N/A'} {bookingInfo?.customer?.last_name}
          </span>
        </div>
        <div className="flex flex-col gap-2">
          <span className="detail-name">Contact</span>
          <span>{bookingInfo?.customer?.phone_number || 'N/A'}</span>
        </div>
        <div className="flex flex-col gap-2">
          <span className="detail-name">Whatsapp</span>
          <span>{bookingInfo?.customer?.whatsapp_number || 'N/A'}</span>
        </div>
        <div className="flex flex-col gap-2">
          <span className="detail-name">Email</span>
          <span>{bookingInfo?.customer?.email || 'N/A'}</span>
        </div>
      </div>
      <section className="flex flex-col gap-2.5 itinerary-details-wrapper">
        <p>{bookingInfo?.itinerary?.route}</p>
        <div className="itinerary-duration flex gap-5">
          <div className="flex items-center gap-2.5">
            <CalendarIconSvg height={20} width={20} fill="#7a7a7a" />
            <span>
              {dayjs(splitDate(bookingInfo?.itinerary?.start_time)).format("DD MMM YYYY")} -{" "}
              {dayjs(splitDate(bookingInfo?.itinerary?.end_time)).format("DD MMM YYYY")}
            </span>
          </div>
          <div className="flex items-center gap-2">
            {bookingInfo?.itinerary?.trip_type?.includes("one") ? (
              <OneWayTripIconSvg height={16} width={16} />
            ) : (
              <RoundTripIconSvg height={20} width={20} />
            )}
            <span className="trip-type">{handleTripType(bookingInfo?.itinerary?.trip_type)}</span>
          </div>
          <div className="flex items-center gap-2">
            <MoonIconSvg fill="#7a7a7a" height={18} width={18} />
            <span>{bookingInfo?.itinerary?.night_count} Nights</span>
          </div>
          <div className="flex items-center gap-2">
            <ShipIconSvg fill="#7a7a7a" height={22} width={20} />
            <span className="text-capitalize">{bookingInfo?.itinerary?.ship_name?.toLowerCase()}</span>
          </div>
          <div className="flex items-center gap-2">
            <UserIconSvg fill="#7a7a7a" />
            <span>{(Number(bookingInfo?.infants) || 0) + (Number(bookingInfo?.children) || 0) + (Number(bookingInfo?.adult) || 0)} Guests</span>
            <OverlayTrigger delay={{ hide: 0, show: 50 }} placement="bottom"
              overlay={
                <Tooltip>
                    {`Adult: ${bookingInfo?.adult || 0}`}
                    <br />
                    {`Children: ${bookingInfo?.children || 0}`}
                    <br />
                    {`Infant: ${bookingInfo?.infants || 0}`}
                </Tooltip>
              }>
              <span className="cursor-pointer">
                <InfoIconSvg fill="#D0566E" />
              </span>
            </OverlayTrigger>
          </div>
        </div>
      </section>
      <div className="flex gap-2">
        <section className="tab-button-section-wrapper flex flex-col gap-2.5">
          <CustomButton fillColor={tabSwitch === 1} onButtonClick={() => setTabSwitch(1)}>
            Cabin Details
          </CustomButton>
          <CustomButton fillColor={tabSwitch === 2} onButtonClick={() => setTabSwitch(2)}>
            Price & Discounts
          </CustomButton>
          {!!ssrData.length && <CustomButton fillColor={tabSwitch === 3} onButtonClick={() => setTabSwitch(3)}>
            Special Services
          </CustomButton>}
        </section>
        {tabSwitch === 1 && (
          <section className="w-100 h-100 max-h-[40vh] rounded overflow-auto view-details-cards-wrapper">
            <div className="view-details-card-wrapper w-100 p-3">
              <BookingsCabinCard bookingInfo={bookingInfo} />
            </div>
          </section>
        )}
        {tabSwitch === 2 && <div className="flex w-100 h-100 gap-2 max-h-[40vh] overflow-auto">
          {price?.total ? <PriceDetail show={true} viewDetail={true} netPrice={price} clx={"inside-view-detail w-100"} discountDescription={bookingInfo?.quotation?.offerDescriptions} /> : <span className="text-center w-full">No Pricing Data Available</span>}          
        </div>}
        {tabSwitch === 3 && !!ssrData.length && <BookingsSsrSection ssrData={ssrData} />}
      </div>
    </div>
  );
};

export default ViewBookingsDetailsModal;
